import { render, staticRenderFns } from "./CustomDropDownRounded.vue?vue&type=template&id=35c5415c&scoped=true"
import script from "./CustomDropDownRounded.vue?vue&type=script&lang=js"
export * from "./CustomDropDownRounded.vue?vue&type=script&lang=js"
import style0 from "./CustomDropDownRounded.vue?vue&type=style&index=0&id=35c5415c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5415c",
  null
  
)

export default component.exports